import React from 'react';

import { setBackground } from '../../utils/style.js';

class TaskListing extends React.Component {
  render() {
    return (
      <div>TaskListing</div>
    );
  }

  componentWillMount() {
    setBackground('pink');
  }
};

export default TaskListing;



// WEBPACK FOOTER //
// ./src/views/TaskListing/index.js